import { render, staticRenderFns } from "./ys-nameplate.vue?vue&type=template&id=dbe7ce24&scoped=true"
var script = {}
import style0 from "./ys-nameplate.vue?vue&type=style&index=0&id=dbe7ce24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe7ce24",
  null
  
)

export default component.exports